import { IHomeQuote, IPaymentPlan } from './IHomePolicy';

export default class HomeQuote {
  personalAccident: boolean;
  rebuildingCost: string;
  publicLiabilityCost: string;
  rentCost: string;
  contentInsurance: string;
  building: boolean;
  buildingContent: boolean;
  publicLiability: boolean;
  personalAccidentIncluded: boolean;
  rent: boolean;
  phone: string;
  id: string;
  reference: string;
  paymentPlan: IPaymentPlan;

  constructor(Imodel?: IHomeQuote) {
    this.personalAccident = Imodel?.personalAccident ?? false;
    this.rebuildingCost = Imodel?.rebuildingCost ?? '0';
    this.publicLiability = Imodel?.publicLiability ?? false;
    this.publicLiabilityCost = Imodel?.publicLiabilityCost ?? '0';
    this.rentCost = Imodel?.rentCost ?? '0';
    this.contentInsurance = Imodel?.contentInsurance ?? '0';
    this.building = Imodel?.building ?? false;
    this.buildingContent = Imodel?.buildingContent ?? false;
    this.personalAccidentIncluded = Imodel?.personalAccidentIncluded ?? false;
    this.rent = Imodel?.rent ?? false;
    this.phone = Imodel?.phone ?? '';
    this.id = Imodel?.id ?? '';
    this.reference = Imodel?.reference ?? '';
    this.paymentPlan = {
      excess: Imodel?.paymentPlan?.excess ?? 0,
      monthlyInstallment: Imodel?.paymentPlan?.monthlyInstallment ?? 0,
      initialDeposit: Imodel?.paymentPlan?.initialDeposit,
      outRightPremium: Imodel?.paymentPlan?.outRightPremium,
      totalInterest: Imodel?.paymentPlan?.totalInterest,
      totalPremium: Imodel?.paymentPlan?.totalPremium,
      installmentPeriod: Imodel?.paymentPlan?.installmentPeriod
    } as IPaymentPlan;
  }
}
